module.exports = __webpack_public_path__ + "img/detail-table-icon.b43f68da.svg";